import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=e71ff74e&scoped=true&"
import script from "./ResultCard.vue?vue&type=script&lang=ts&"
export * from "./ResultCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResultCard.vue?vue&type=style&index=0&id=e71ff74e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ff74e",
  null
  
)

export default component.exports